/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_When_MovementInputs */

const en_us2_bodymap_when_movement = /** @type {(inputs: Bodymap_When_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When I move`)
};

const pt_br2_bodymap_when_movement = /** @type {(inputs: Bodymap_When_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando me movimento`)
};

const es_419_bodymap_when_movement = /** @type {(inputs: Bodymap_When_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando me muevo`)
};

const pt_pt2_bodymap_when_movement = /** @type {(inputs: Bodymap_When_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando me mexo`)
};

const fr_fr2_bodymap_when_movement = /** @type {(inputs: Bodymap_When_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand je bouge`)
};

const de_de2_bodymap_when_movement = /** @type {(inputs: Bodymap_When_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Bewegung`)
};

const it_it2_bodymap_when_movement = /** @type {(inputs: Bodymap_When_MovementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando mi muovo`)
};

/**
* | output |
* | --- |
* | "When I move" |
*
* @param {Bodymap_When_MovementInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_when_movement = /** @type {((inputs?: Bodymap_When_MovementInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_When_MovementInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_when_movement(inputs)
	if (locale === "es-419") return es_419_bodymap_when_movement(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_when_movement(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_when_movement(inputs)
	if (locale === "de-DE") return de_de2_bodymap_when_movement(inputs)
	if (locale === "it-IT") return it_it2_bodymap_when_movement(inputs)
	return en_us2_bodymap_when_movement(inputs)
});
export { bodymap_when_movement as "bodymap.when.movement" }